<app-dialog-heading heading="Document Overview"></app-dialog-heading>

<mat-grid-list cols="2" rowHeight="75px">
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Select Document Type</mat-label>
      <mat-select (selectionChange)="onDocumentTypeChanged($event.value)">
        <mat-option *ngFor="let option of options" [value]="option">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>

  <mat-grid-tile>
    <button mat-raised-button
            color="primary"
            [disabled]="isDownloadButtonDisabled() || isLoading"
            (click)="downloadDocument()">
      <mat-icon>download</mat-icon>
      Download Document
    </button>

    <div *ngIf="errorMessage" class="flex justify-start ml2">
      <p style="color: red">{{ errorMessage }}</p>
    </div>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="2" rowHeight="75px">
  <mat-grid-tile *ngIf="selectedDocument?.code === 'STM'">
    <ng-container [ngTemplateOutlet]="datePickerTemplate"
                  [ngTemplateOutletContext]="{
              label:'Select Statement Month',
              maxDate: _maxYearMonth,
              formControlInstance: dateForm
              }">
    </ng-container>
  </mat-grid-tile>

  <mat-grid-tile *ngIf="selectedDocument?.code === 'TAX'">
    <ng-container [ngTemplateOutlet]="datePickerTemplate"
                  [ngTemplateOutletContext]="{
              label:'Select Tax Year',
              maxDate: _maxYear,
              formControlInstance: dateForm
              }">
    </ng-container>
  </mat-grid-tile>
</mat-grid-list>

<section class="flex justify-center m2 mb2">
  <i class="reports-logo"></i>
</section>

<ng-template #datePickerTemplate
             let-label="label"
             let-formControlInstance="formControlInstance"
             let-maxDate="maxDate"
>
  <mat-form-field>
    <mat-label> {{ label }}</mat-label>
    <input [formControl]="formControlInstance" matInput [max]="maxDate"
           [matDatepicker]="selectedDocument?.code === 'STM' ?selectMonthYear : selectYear">
    <mat-datepicker-toggle [for]="selectedDocument?.code === 'STM' ?selectMonthYear : selectYear" matSuffix>
      <mat-icon class="icon-display" matDatepickerToggleIcon>today</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker-toggle matSuffix (click)="formControlInstance.reset()">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #selectMonthYear startView="multi-year"
                    (monthSelected)="setMonthAndYear($event, selectMonthYear)"></mat-datepicker>
    <mat-datepicker #selectYear startView="multi-year"
                    (yearSelected)="setMonthAndYear($event, selectYear)"></mat-datepicker>
  </mat-form-field>
</ng-template>
